module.exports = __webpack_public_path__ + "img/ru_failure_2.b1f1b488.png";